import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  SeHouseholdSetupFeatureAlreadyHaveAccountModule
} from '@se-po/se-household-setup-feature-already-have-account'
import { RecaptchaModule } from 'ng-recaptcha'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { seFeIconHidden, seFeIconInfoCircle, SeFeIconModule, seFeIconVisible } from 'se-fe-icon'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFePopoverModule } from 'se-fe-popover'
import { SeFeSpinnerModule } from 'se-fe-spinner'

import { CreatePasswordComponent } from './create-password/create-password.component'
import { PasswordFormCreateService } from './create-password/password-form-create.service'

@NgModule({
  declarations: [CreatePasswordComponent],
  exports: [CreatePasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    SeHouseholdSetupFeatureAlreadyHaveAccountModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeFormFieldModule,
    SeFeFormFieldOptionsModule,
    SeFeFormFieldTextModule,
    SeFeIconModule.include([seFeIconInfoCircle, seFeIconVisible, seFeIconHidden]),
    SeFeLinkModule,
    SeFePopoverModule,
    SeFeSpinnerModule,
  ],
  providers: [PasswordFormCreateService]
})
export class SeHouseholdSetupFeatureCreatePasswordModule { }
